import { html } from 'lit';

export const processTextWithMentions = (
  text = '',
  mentionedUsers = [],
  handleMentionClick = () => { },
  isSelf = true
) => {
  if (!text) return '';

  const segments = [];

  let remainingText = text;

  for (const user of mentionedUsers || []) {
    const userName = user?.userName;
    if (!userName) continue;

    const mention = `@${userName}`;

    let parts = remainingText.split(mention);
    if (parts.length <= 1) continue; 

    let newSegments = [];
    let processedText = '';

    for (let i = 0; i < parts.length; i++) {
      if (parts[i]) {
        newSegments.push({ type: 'text', content: parts[i] });
      }

      if (i < parts.length - 1) {
        newSegments.push({
          type: 'mention',
          content: mention,
          user: user
        });
      }
    }

    segments.push(...newSegments);
    remainingText = '';
  }

  if (segments.length === 0 && text) {
    segments.push({ type: 'text', content: text });
  }

  const finalSegments = [];
  for (const segment of segments) {
    if (segment.type === 'text') {
      const processedLinks = processLinks(segment.content);
      finalSegments.push(...processedLinks);
    } else {
      finalSegments.push(segment);
    }
  }

  return finalSegments.map(segment => {
    if (segment.type === 'text') {
      return segment.content;
    } else if (segment.type === 'mention') {
      return html`
        <span 
          class="mention" 
          style="color: ${isSelf ? 'var(--text-outgoing-message)' : 'var(--text-incoming-message)'}; font-weight: bold;cursor: pointer;"
          @click=${() => handleMentionClick(segment.user)}
        >${segment.content}</span>
      `;
    } else if (segment.type === 'link') {
      return html`
        <a 
          href=${segment.url}
          target="_blank"
          rel="noopener noreferrer"
          style="color: ${isSelf ? 'var(--text-outgoing-message)' : 'var(--text-incoming-message)'};"
        >${segment.content}</a>
      `;
    }
    return '';
  });
};

const processLinks = (text) => {
  if (!text) return [{ type: 'text', content: '' }];

  const urlRegex = /https?:\/\/[^\s]+/g;
  let match;
  let lastIndex = 0;
  const segments = [];

  if (!text.match(urlRegex)) {
    return [{ type: 'text', content: text }];
  }

  while ((match = urlRegex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      segments.push({
        type: 'text',
        content: text.substring(lastIndex, match.index)
      });
    }

    const url = match[0];

    segments.push({
      type: 'link',
      content: url,
      url: url 
    });

    lastIndex = match.index + url.length;
  }

  if (lastIndex < text.length) {
    segments.push({
      type: 'text',
      content: text.substring(lastIndex)
    });
  }

  return segments;
};